import {Alert, Button, Popover, Row, Space} from "antd";
import {useChoiceAnalysisFastQuotationMutation, useGetNegotiationDetailQuery} from "../../redux/api/negotiationsApiSlice";
import {skipToken} from "@reduxjs/toolkit/query";
import {useParams} from "react-router-dom";
import {assistantBg, assistantBorder, assistantColor, CustomRobotIcon} from "./sidebars/AIAssistant/utils/CustomRobotIcon";
import {useState} from "react";
import {JOB_STATUS} from "../../types/reconciliation";
import ReactMarkdown from "react-markdown";
import {CheckCircleOutlined, CloseCircleOutlined} from "@ant-design/icons";

export default function FastQuotation({isCurrentStep, startPolling, callBackUpdateNegotiation}: {
    isCurrentStep: boolean,
    startPolling: () => void,
    callBackUpdateNegotiation: () => void
}) {
    const {id} = useParams()

    const {data: negotiationData} = useGetNegotiationDetailQuery(id ?? skipToken)
    const [fastQuotationChoice, {isLoading: fastQuotationLoading}] = useChoiceAnalysisFastQuotationMutation()

    const [popoverDeclineOpen, setPopoverDeclineOpen] = useState<boolean>(false)
    const [popoverAcceptOpen, setPopoverAcceptOpen] = useState<boolean>(false)

    const acceptFastQuotation = () => {
        setPopoverDeclineOpen(false)
        if (id) {
            fastQuotationChoice({negID: id, uw_accepted_fastquotation_suggestion: true})
                .then(res => startPolling())
        }
    }

    const rejectFastQuotation = () => {
        setPopoverAcceptOpen(false)
        if (id) {
            fastQuotationChoice({negID: id, uw_accepted_fastquotation_suggestion: false}).unwrap()
                .then(res => callBackUpdateNegotiation())
        }
    }

    const declineFastquotationPopoverContent = () => {
        return <div>
            Rifiutando la fast quotation sarà comunque possibile calcolare il premio applicando manualmente il pricing tool <br/>
            Confermi di rifiutare la fast quotation?
            <Row justify={"end"} style={{marginTop: "1rem"}}>
                <Button size={"small"} type={"primary"} danger onClick={() => rejectFastQuotation()}>
                    Rifiuta
                </Button>
            </Row>
        </div>
    }

    const continueAnalysisPopoverContent = () => {
        return <div>
            Continuando con l'analisi verrà calcolato automaticamente il premio tramite pricing tool. <br/>
            I dati attualmente presenti potranno essere sovrascritti. <br/>
            Si desidera continuare?
            <Row justify={"end"} style={{marginTop: "1rem"}}>
                <Button size={"small"} type={"primary"} onClick={() => acceptFastQuotation()}>
                    Continua
                </Button>
            </Row>
        </div>
    }

    return (
        <div style={{marginTop: "1rem", marginBottom: "1rem"}}>
            <Alert
                style={{
                    color: assistantColor,
                    backgroundColor: assistantBg,
                    borderColor: assistantBorder,
                    marginBottom: '1rem',
                }}
                type={"info"}
                message={<strong style={{color: assistantColor}}>ERIK:</strong>}
                description={<ReactMarkdown>{negotiationData?.negotiation_analysis?.fastquotation_suggestion_message}</ReactMarkdown>}
                showIcon
                icon={<CustomRobotIcon/>}
            />
            {
                negotiationData?.negotiation_analysis?.is_fastquotation_suggested
                    ? <div
                        style={{
                            alignItems: "center",
                            color: assistantColor,
                            display: "inline-flex",
                            marginBottom: "1rem",
                            justifyContent: "center",
                        }}
                    >
                        <CheckCircleOutlined
                            style={{
                                display: "inline-block",
                                fontSize: "1.25rem",
                                marginRight: "0.5rem",
                                verticalAlign: "middle",
                            }}
                        />
                        <div>
                            ERIK consiglia di procedere con la quotazione Fast Quotation
                        </div>
                    </div>
                    : <div
                        style={{
                            alignItems: "center",
                            color: assistantColor,
                            display: "inline-flex",
                            justifyContent: "center",
                        }}
                    >
                        <CloseCircleOutlined
                            style={{
                                display: "inline-block",
                                fontSize: "1.25rem",
                                marginRight: "0.5rem",
                                verticalAlign: "middle",
                            }}
                        />
                        <div>
                            ERIK consiglia di procedere con la quotazione Tailor Made
                        </div>
                    </div>
            }
            {negotiationData?.negotiation_analysis?.analysis_status !== JOB_STATUS.ERROR && isCurrentStep && negotiationData?.negotiation_analysis?.uw_accepted_fastquotation_suggestion === null &&
                <Row justify={"center"} style={{marginTop: "1rem"}}>
                    <Space>
                        <Popover placement="top"
                                 title={"Attenzione"}
                                 content={declineFastquotationPopoverContent()}
                                 open={popoverDeclineOpen}
                                 onOpenChange={open => setPopoverDeclineOpen(open)}
                                 trigger={"click"}>
                            <Button
                                type={"primary"}
                                loading={fastQuotationLoading}
                                danger>
                                Rifiuta Fast Quotation
                            </Button>
                        </Popover>
                        <Popover placement={"top"}
                                 title={"Attenzione"}
                                 content={continueAnalysisPopoverContent()}
                                 open={popoverAcceptOpen}
                                 trigger={"click"}
                                 onOpenChange={open => setPopoverAcceptOpen(open)}>
                            <Button
                                loading={fastQuotationLoading}
                                type={"primary"}>
                                Applica quotazione Fast Quotation
                            </Button>
                        </Popover>
                    </Space>
                </Row>}
        </div>
    );
}